import clsx from "clsx";

import { ShortcutIconObject } from "@components/ShortCutsBlock";

import shortcutsStyles from "./shortcut.module.css";

interface ShortcutProps {
  label?: string;
  text?: string;
  icon?: ShortcutIconObject;
  overrideIconBackground?: string;
  removeContentBorder?: boolean;
  useIconBorder?: boolean;
  className?: string;
  [htmlAttributes: string]: any;
}

export const Shortcut = ({
  label,
  text,
  icon,
  overrideIconBackground,
  removeContentBorder,
  useIconBorder,
  className,
  ...htmlAttributes
}: ShortcutProps): React.ReactNode => {
  const iconColorBackground = icon?.backgroundColor || "#c8ebfa";
  const backgroundColor = overrideIconBackground || iconColorBackground;
  return (
    <div className={clsx(shortcutsStyles.shortcut, { [className]: className })} {...htmlAttributes}>
      <div
        className={clsx(shortcutsStyles.iconWrapper, {
          [shortcutsStyles.useIconBorder]: useIconBorder,
        })}
        style={{ backgroundColor: backgroundColor }}
      >
        {icon?.iconId ? <img src={`/images/icons/${icon?.iconId}.svg`} alt="" /> : <div></div>}
      </div>
      <div
        className={clsx(shortcutsStyles.labelWrapper, {
          [shortcutsStyles.removeContentBorder]: removeContentBorder,
        })}
      >
        {label && <span className={shortcutsStyles.labelText}>{label}</span>}
        {text && <span className={shortcutsStyles.description}>{text}</span>}
      </div>
    </div>
  );
};
